// extracted by mini-css-extract-plugin
export var chevron = "_fr-2";
export var dropdownItems = "_fr-0";
export var item = "_fr-1";